import { ProductDetailPage } from "./ProductDetailPage";

export function OnlineShowcaseProductDetailPage() {
  return <ProductDetailPage catalogMode="online-showcase" />;
}
